export default "__VITE_ASSET__CcPaa1g3__"